AAcom.modules.cancelDialog = function (AAUI) {
    AAUI.util = new aa_Utilities();
    let cancelTripDialog;
    let cancelEligible;
    let reservationType;

    const recordLocator = AAUI.getProperty('recordLocator');
    const displayFlightCard = AAUI.getProperty('displayFlightCard');
    const displayChangeResButton = AAUI.getProperty('displayChangeResButton');
    const transactionId = AAUI.getProperty('transactionId');
    const loadingText = AAUI.getProperty('loadingText');

    function sendAnalytics(eligible, type) {
        waTealiumUtils.reportJsonEvent({
            event_category: 'Modal',
            event_action: 'view',
            event_name: `Cancel Trip ${eligible ? 'Eligible' : 'Ineligible'}`,
            reservation_type: type,
            error_id: `${getErrCode(type)}`
        }, 'click');
    }

    function getErrCode(resType) {
        switch (resType) {
            case 'travelAgency':
                return 'ERRCODE1567';
            case 'corporate':
                return 'ERRCODE1553'
            case 'AAVacations':
                return  'ERRCODE1671'
            default:
                return 'ERRCODE1315'
        }
    }

    AAUI.initCancelTripDialog = function (element, eligible) {
        const buttons = [];
        const maxHeight = eligible ? 350 : 300;

        if (eligible) {
            buttons.push({
                name: AAUI.getProperty('cancelTripButton'),
                cssClass: 'btn',
                callback: function () {
                    $j('#cancelForm')
                        .trigger('submit');
                    $j('body')
                        .aaBusy({ message: loadingText })
                        .start();
                },
                closeDialog: true
            });

            buttons.push({
                name: AAUI.getProperty('goBackButton'),
                cssClass: 'btn btn-secondary',
                closeDialog: true
            });
        } else {
            buttons.push({
                name: AAUI.getProperty('closeButton'),
                cssClass: 'btn',
                closeDialog: true
            });
        }

        cancelTripDialog = AAUI.util.aaDialog(element, {
            width: 'large',
            maxHeight,
            toggleScroll: true,
            autoOpen: false,
            buttons
        });

        cancelTripDialog.openDialog();
    };

    AAUI.onClick('#cancelLink', function () {
        if (cancelTripDialog) {
            sendAnalytics(cancelEligible, reservationType);
            cancelTripDialog.openDialog();
            return;
        }

        AAUI.ajaxRequest({
            url: `/cancel/eligibility?recordLocator=${recordLocator}&displayFlightCard=${displayFlightCard}&displayChangeResButton=${displayChangeResButton}&transactionId=${transactionId}`,
            method: 'GET',
            updateContainer: '#cancel-modal',
            busyContainer: 'body',
            busyMessage: loadingText,
            onSuccess(res) {
                const elementArray = $j.parseHTML(res.trim());
                const element = $j(elementArray[0]);
                const refundSpa = element.data('redirect');
                cancelEligible = element.data('eligible');
                reservationType = element.data('type');

                if (refundSpa) {
                    window.location = refundSpa;
                } else {
                    sendAnalytics(cancelEligible, reservationType);
                    AAUI.initCancelTripDialog(element, cancelEligible);
                }
            }
        });
    });
};
